export const SiteTypeEnum = {
  School: 1,
  Warehouse: 2,
  Kitchen: 3,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/SiteTypeEnum.js